const security = require('../config/security.js');

module.exports = class SecurityService {

  static $inject = [
    '$http',
    '$interval',
    '$log',
    '$ngRedux',
    '$state',
    'SessionService',
  ];

  constructor($http, $interval, $log, $ngRedux, $state, SessionService) {
    this.$http = $http;
    this.$interval = $interval;
    this.$log = $log;
    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.SessionService = SessionService;
  }

  authenticate(email, password, asAccount = false) {
    const credentials = btoa(`${email}:${password}`);
    const group = this.$ngRedux.getState().group;

    return this.$http({
      method: 'POST',
      url: (asAccount ? security.endpoints.accountAuth : security.endpoints.auth),
      headers: {
        [security.header]: `${security.schemes.auth} ${credentials}`,
      },
    })
    .then((response) => {
      if (!_.some(response.data.session.groups, { id: group.id })) {
        // If patient session groups do not include current group, shows an error
        return { error: 'patient_not_created' };
      }
      this.SessionService.store(response.data.session);

      return { error: false, session: response.data.session };
    }, (response) => {
      const error = response.data.error && response.data.error.replace('api.errors.', '');

      return { error };
    });
  }

  authenticateWithToken(token) {
    return this.$http({
      method: 'POST',
      url: security.endpoints.auth,
      headers: {
        [security.header]: `${security.schemes.default} ${token}`,
      },
    });
  }

  logout() {
    return this.$http.post('/api/v2/patient/logout');
  }

  poll() {
    if (application.env !== 'test') {
      this.$interval(this.ping.bind(this), this.intervalDuration());
    }
  }

  ping() {
    this.$http.get('/api/v2/ping');
  }

  intervalDuration() {
    return moment.duration(5, 'minutes').asMilliseconds();
  }

  logoutAccount() {
    return this.$http.post('api/v2/account/logout');
  }
};



// WEBPACK FOOTER //
// ./main/services/security-service.js